/* ============================================================
   meuAuAu Theme — application.js
   Shopify 2.0 — Vanilla JS
   ============================================================ */

'use strict';

/* ── Utilidades ─────────────────────────────────────────────── */

function $(sel, ctx) { return (ctx || document).querySelector(sel); }
function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

function debounce(fn, delay) {
  let timer;
  return function(...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}

function escapeHtml(str) {
  if (str == null) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function showToast(message, type) {
  var existing = $('.toast');
  if (existing) existing.remove();

  var toast = document.createElement('div');
  toast.className = 'toast' + (type === 'error' ? ' toast--error' : '');
  toast.style.background = type === 'error' ? '#DC2626' : '#16A34A';
  /* SVG icon (estático/seguro) + texto vía textContent (evita XSS) */
  var iconWrap = document.createElement('span');
  iconWrap.innerHTML =
    '<svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24">' +
    (type === 'error'
      ? '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>'
      : '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>') +
    '</svg>';
  var msgWrap = document.createElement('span');
  msgWrap.textContent = message;
  toast.appendChild(iconWrap);
  toast.appendChild(msgWrap);

  document.body.appendChild(toast);
  setTimeout(function() {
    toast.classList.add('toast--hidden');
    setTimeout(function() { toast.remove(); }, 300);
  }, 2500);
}

/* ── AJAX Cart API ───────────────────────────────────────────── */

var MeuAuAuCart = {
  async add(variantId, quantity, properties) {
    quantity = quantity || 1;
    var body = { id: variantId, quantity: quantity };
    if (properties) body.properties = properties;

    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
    if (!res.ok) throw await res.json();
    return res.json();
  },

  async get() {
    var res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return res.json();
  },

  async update(updates) {
    var res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
    return res.json();
  },

  async remove(key) {
    var res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    return res.json();
  },

  async getCount() {
    var cart = await this.get();
    return cart.item_count;
  },

  updateCountBadges(count) {
    $$('[data-cart-count]').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }
};

/* ── Header: menú móvil ──────────────────────────────────────── */

function initMobileMenu() {
  var btn     = $('#mobile-menu-btn');
  var menu    = $('#mobile-menu');
  var overlay = $('#mobile-menu-overlay');

  if (!btn || !menu) return;

  function open() {
    menu.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    btn.querySelector('[data-icon-open]') && (btn.querySelector('[data-icon-open]').style.display = 'none');
    btn.querySelector('[data-icon-close]') && (btn.querySelector('[data-icon-close]').style.display = 'block');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    menu.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
    btn.querySelector('[data-icon-open]') && (btn.querySelector('[data-icon-open]').style.display = 'block');
    btn.querySelector('[data-icon-close]') && (btn.querySelector('[data-icon-close]').style.display = 'none');
    document.body.style.overflow = '';
  }

  btn.addEventListener('click', function() {
    menu.classList.contains('is-open') ? close() : open();
  });

  overlay && overlay.addEventListener('click', close);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') close();
  });
}

/* ── Hero Carousel ───────────────────────────────────────────── */

function initHeroCarousel() {
  var carousel = $('#hero-carousel');
  if (!carousel) return;

  var slides  = $$('[data-slide]', carousel);
  var dots    = $$('[data-dot]', carousel);
  var prevBtn = $('[data-prev]', carousel);
  var nextBtn = $('[data-next]', carousel);
  var total   = slides.length;

  if (total <= 1) {
    if (prevBtn) prevBtn.style.display = 'none';
    if (nextBtn) nextBtn.style.display = 'none';
    return;
  }

  var current   = 0;
  var isDragging = false;
  var startX    = 0;
  var dragDelta = 0;
  var interval;

  function goTo(index) {
    slides[current].classList.remove('is-active');
    dots[current] && dots[current].classList.remove('is-active');
    current = (index + total) % total;
    slides[current].classList.add('is-active');
    dots[current] && dots[current].classList.add('is-active');
  }

  function startAutoplay() {
    interval = setInterval(function() {
      if (!isDragging) goTo(current + 1);
    }, 5000);
  }

  function stopAutoplay() {
    clearInterval(interval);
  }

  prevBtn && prevBtn.addEventListener('click', function() { stopAutoplay(); goTo(current - 1); startAutoplay(); });
  nextBtn && nextBtn.addEventListener('click', function() { stopAutoplay(); goTo(current + 1); startAutoplay(); });

  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() { stopAutoplay(); goTo(i); startAutoplay(); });
  });

  /* Drag / swipe */
  var track = $('[data-carousel-track]', carousel) || carousel;

  function onDragStart(x) { isDragging = true; startX = x; dragDelta = 0; stopAutoplay(); }
  function onDragMove(x)  { if (!isDragging) return; dragDelta = x - startX; }
  function onDragEnd()    {
    if (!isDragging) return;
    isDragging = false;
    if (Math.abs(dragDelta) > 50) {
      dragDelta > 0 ? goTo(current - 1) : goTo(current + 1);
    }
    dragDelta = 0;
    startAutoplay();
  }

  track.addEventListener('mousedown',  function(e) { onDragStart(e.pageX); });
  track.addEventListener('mousemove',  function(e) { onDragMove(e.pageX); });
  track.addEventListener('mouseup',    onDragEnd);
  track.addEventListener('mouseleave', onDragEnd);
  track.addEventListener('touchstart', function(e) { onDragStart(e.touches[0].pageX); }, { passive: true });
  track.addEventListener('touchmove',  function(e) { onDragMove(e.touches[0].pageX); },  { passive: true });
  track.addEventListener('touchend',   onDragEnd);

  goTo(0);
  startAutoplay();
}

/* ── Scroll carrusel (categorías / destaques) ──────────────── */

function initScrollCarousels() {
  $$('[data-scroll-carousel]').forEach(function(container) {
    var id = container.dataset.scrollCarousel;
    var prevBtn = $('[data-scroll-prev="' + id + '"]');
    var nextBtn = $('[data-scroll-next="' + id + '"]');
    var amount  = parseInt(container.dataset.scrollAmount || '220');

    prevBtn && prevBtn.addEventListener('click', function() {
      container.scrollBy({ left: -amount, behavior: 'smooth' });
    });
    nextBtn && nextBtn.addEventListener('click', function() {
      container.scrollBy({ left: amount, behavior: 'smooth' });
    });
  });
}

/* ── Galería por variante ────────────────────────────────────── */

function filterGalleryByVariant(variantTitle) {
  var gallery = $('#product-gallery');
  if (!gallery) return;

  var allThumbs = $$('[data-gallery-thumb]', gallery);
  if (allThumbs.length === 0) return;

  /* Normaliza para comparação case-insensitive */
  var title = (variantTitle || '').toLowerCase().trim();

  /* Filtra: mostra thumb se alt vazio (global) OU se o título da variante contém o alt */
  var visible = allThumbs.filter(function(thumb) {
    var alt = (thumb.dataset.imgAlt || '').trim();
    if (alt === '') return true;            // sem alt = imagem global
    return title.indexOf(alt) !== -1;       // alt está contido no título
  });

  /* Fallback: sem match → mostra todas */
  if (visible.length === 0) visible = allThumbs;

  /* Oculta todos, exibe apenas os filtrados */
  allThumbs.forEach(function(thumb) {
    thumb.style.display = 'none';
    thumb.classList.remove('is-active');
    thumb.setAttribute('aria-pressed', 'false');
  });

  visible.forEach(function(thumb, i) {
    thumb.style.display = '';
    if (i === 0) {
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-pressed', 'true');
    }
  });

  /* Atualiza imagem principal com fade para o primeiro thumb visível */
  var mainImg = $('[data-gallery-main-img]', gallery);
  if (mainImg && visible[0]) {
    var newSrc = visible[0].dataset.full || (visible[0].querySelector('img') && visible[0].querySelector('img').src) || '';
    if (newSrc && mainImg.src.split('?')[0] !== newSrc.split('?')[0]) {
      mainImg.classList.add('vg-fading');
      setTimeout(function() {
        mainImg.src    = newSrc;
        mainImg.srcset = '';
        mainImg.classList.remove('vg-fading');
      }, 150);
    }
  }
}

/* ── Página de producto: variantes + añadir al carrito ─────── */

function initProductPage() {
  var form = $('#product-form');
  if (!form) return;

  var addBtn      = $('#add-to-cart-btn');
  var buyBtn      = $('#buy-now-btn');
  var variantInput = $('[name="id"]', form);

  /* Botones de variante (talla / estampado) */
  $$('[data-variant-btn]', form).forEach(function(btn) {
    btn.addEventListener('click', function() {
      var group = btn.dataset.variantGroup;
      $$('[data-variant-btn][data-variant-group="' + group + '"]', form).forEach(function(b) {
        b.classList.remove('is-selected');
      });
      btn.classList.add('is-selected');
      updateVariantId();
    });
  });

  function updateVariantId() {
    var variantJsonEl = document.getElementById('product-variants-json');
    var variantData = variantJsonEl ? JSON.parse(variantJsonEl.textContent) : [];
    if (variantData.length === 0) return;

    /* Usa data-variant-group (posição real do Shopify, 1-indexed) para
       garantir que selectedOptions[i] bata com v.options[i],
       independente da ordem dos elementos no DOM. */
    var selectedOptions = [];
    $$('[data-variant-btn].is-selected', form).forEach(function(b) {
      var pos = parseInt(b.dataset.variantGroup, 10) - 1; // 0-indexed
      if (!isNaN(pos)) selectedOptions[pos] = b.dataset.variantValue;
    });

    var matched = variantData.find(function(v) {
      return v.options.every(function(opt, i) {
        return !selectedOptions[i] || selectedOptions[i] === opt;
      });
    });

    if (matched) {
      variantInput.value = matched.id;
      updatePriceDisplay(matched);
      updateAvailability(matched.available);
      filterGalleryByVariant(matched.options.join(' / '));
    }
  }

  function updatePriceDisplay(variant) {
    var priceEl   = $('#product-price');
    var compareEl = $('#product-price-compare');
    var badgeEl   = $('#product-discount-badge');
    if (!priceEl) return;

    priceEl.textContent = formatMoney(variant.price);

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      compareEl && (compareEl.textContent = formatMoney(variant.compare_at_price));
      compareEl && (compareEl.style.display = 'block');
      if (badgeEl) {
        var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
        badgeEl.textContent = '-' + pct + '%';
        badgeEl.style.display = 'inline-flex';
      }
    } else {
      compareEl && (compareEl.style.display = 'none');
      badgeEl   && (badgeEl.style.display   = 'none');
    }
  }

  function updateAvailability(available) {
    var qtyWrapper = $('#product-qty-wrapper');
    if (qtyWrapper) qtyWrapper.style.display = available ? '' : 'none';
    if (!addBtn) return;
    addBtn.disabled = !available;
    var label = $('[data-add-label]', addBtn);
    if (label) label.textContent = available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSoldOut;
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'EUR' });
  }

  /* Selector de cantidad */
  var qtyInput = $('[data-qty-input]', form);
  $('[data-qty-minus]', form) && $('[data-qty-minus]', form).addEventListener('click', function() {
    var val = parseInt(qtyInput.value) || 1;
    if (val > 1) qtyInput.value = val - 1;
  });
  $('[data-qty-plus]', form) && $('[data-qty-plus]', form).addEventListener('click', function() {
    var val = parseInt(qtyInput.value) || 1;
    qtyInput.value = val + 1;
  });

  /* Añadir al carrito */
  addBtn && addBtn.addEventListener('click', async function(e) {
    e.preventDefault();
    var id  = variantInput.value;
    var qty = parseInt((qtyInput && qtyInput.value) || 1);
    if (!id) return;

    addBtn.disabled = true;
    var originalLabel = $('[data-add-label]', addBtn);
    if (originalLabel) originalLabel.textContent = '...';

    try {
      await MeuAuAuCart.add(id, qty);
      var count = await MeuAuAuCart.getCount();
      MeuAuAuCart.updateCountBadges(count);
      showToast('¡Añadido al carrito!');
      if (originalLabel) originalLabel.textContent = addBtn.dataset.labelAdded || '¡Añadido!';
      setTimeout(function() {
        if (originalLabel) originalLabel.textContent = addBtn.dataset.labelAdd || 'Añadir al carrito';
        addBtn.disabled = false;
      }, 2000);
    } catch (err) {
      showToast(err.description || 'Error al añadir al carrito', 'error');
      addBtn.disabled = false;
      if (originalLabel) originalLabel.textContent = addBtn.dataset.labelAdd || 'Añadir al carrito';
    }
  });

  /* Comprar ahora */
  buyBtn && buyBtn.addEventListener('click', async function(e) {
    e.preventDefault();
    var id  = variantInput.value;
    var qty = parseInt((qtyInput && qtyInput.value) || 1);
    if (!id) return;

    buyBtn.disabled = true;
    try {
      await MeuAuAuCart.add(id, qty);
      window.location.href = '/cart';
    } catch (err) {
      showToast(err.description || 'Error', 'error');
      buyBtn.disabled = false;
    }
  });
}

/* ── Página del carrito ──────────────────────────────────────── */

function initCartPage() {
  if (!$('#cart-page')) return;

  /* Cambiar cantidad */
  document.addEventListener('click', async function(e) {
    var btn = e.target.closest('[data-cart-qty-change]');
    if (!btn) return;
    e.preventDefault();

    var key   = btn.dataset.key;
    var delta = parseInt(btn.dataset.delta || '0');
    var row   = btn.closest('[data-cart-item]');
    var qtyEl = row && $('[data-item-qty]', row);
    if (!qtyEl) return;

    var newQty = Math.max(0, parseInt(qtyEl.textContent) + delta);
    btn.disabled = true;

    try {
      var updates = {};
      updates[key] = newQty;
      var cart = await MeuAuAuCart.update(updates);
      MeuAuAuCart.updateCountBadges(cart.item_count);
      if (newQty === 0) {
        row.style.opacity = '0';
        row.style.transform = 'scale(.95)';
        setTimeout(function() { location.reload(); }, 300);
      } else {
        qtyEl.textContent = newQty;
        updateCartTotals(cart);
        btn.disabled = false;
      }
    } catch (err) {
      showToast('Error al actualizar', 'error');
      btn.disabled = false;
    }
  });

  /* Eliminar ítem */
  document.addEventListener('click', async function(e) {
    var btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    e.preventDefault();

    var key = btn.dataset.key;
    var row = btn.closest('[data-cart-item]');
    btn.disabled = true;

    try {
      var cart = await MeuAuAuCart.remove(key);
      MeuAuAuCart.updateCountBadges(cart.item_count);
      if (cart.item_count === 0) {
        location.reload();
      } else {
        if (row) {
          row.style.transition = 'opacity .3s, transform .3s';
          row.style.opacity = '0';
          row.style.transform = 'scale(.95)';
          setTimeout(function() { location.reload(); }, 300);
        }
      }
    } catch (err) {
      showToast('Error al eliminar', 'error');
      btn.disabled = false;
    }
  });

  function updateCartTotals(cart) {
    var formatted = (cart.total_price / 100).toLocaleString('es-ES', {
      style: 'currency',
      currency: cart.currency || 'EUR'
    });
    var totalEls = $$('[data-cart-total], [data-cart-subtotal]');
    totalEls.forEach(function(el) { el.textContent = formatted; });

    var countEls = $$('[data-cart-items-count]');
    countEls.forEach(function(el) { el.textContent = cart.item_count; });

    if (window.MeuAuAuCartShipping && typeof window.MeuAuAuCartShipping.refreshWithCart === 'function') {
      window.MeuAuAuCartShipping.refreshWithCart(cart);
    }
  }
}

/* ── Filtros de colección ────────────────────────────────────── */

function initCollectionFilters() {
  var sortSelect = $('#sort-by');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url  = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* Filtro de búsqueda en colección */
  var searchInput = $('#collection-search');
  if (searchInput) {
    searchInput.addEventListener('input', debounce(function() {
      var q = this.value.trim();
      if (q.length >= 2) {
        window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
      }
    }, 400));
  }
}

/* ── Galería de producto ─────────────────────────────────────── */

function initProductGallery() {
  var gallery = $('#product-gallery');
  if (!gallery) return;

  var mainImg = $('[data-gallery-main-img]', gallery);
  var thumbs  = $$('[data-gallery-thumb]', gallery);
  var modal   = $('#gallery-modal');
  var modalImg = modal && $('[data-modal-img]', modal);

  thumbs.forEach(function(thumb, i) {
    thumb.addEventListener('click', function() {
      thumbs.forEach(function(t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (mainImg) {
        mainImg.src    = thumb.dataset.full || thumb.querySelector('img').src;
        mainImg.srcset = '';
      }
    });
  });

  /* Filtra a galeria para a variante pré-selecionada ao carregar */
  var preSelectedBtns = $$('[data-variant-btn].is-selected');
  if (preSelectedBtns.length > 0) {
    var initialTitle = preSelectedBtns.map(function(b) { return b.dataset.variantValue; }).join(' / ');
    filterGalleryByVariant(initialTitle);
  }

  /* Abrir modal al hacer clic en imagen principal */
  mainImg && mainImg.addEventListener('click', function() {
    if (!modal) return;
    if (modalImg) modalImg.src = mainImg.src;
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  });

  /* Cerrar modal */
  if (modal) {
    var closeBtn  = $('[data-modal-close]', modal);
    var prevBtn   = $('[data-modal-prev]', modal);
    var nextBtn   = $('[data-modal-next]', modal);
    var activeIdx = 0;
    var allThumbs = thumbs;

    closeBtn && closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function(e) { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function(e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowLeft')  navigate(-1);
      if (e.key === 'ArrowRight') navigate(1);
    });

    prevBtn && prevBtn.addEventListener('click', function() { navigate(-1); });
    nextBtn && nextBtn.addEventListener('click', function() { navigate(1); });

    function navigate(dir) {
      var visibleThumbs = $$('[data-gallery-thumb]', gallery).filter(function(t) {
        return t.style.display !== 'none';
      });
      if (visibleThumbs.length === 0) return;
      activeIdx = (activeIdx + dir + visibleThumbs.length) % visibleThumbs.length;
      if (modalImg) modalImg.src = visibleThumbs[activeIdx].dataset.full || visibleThumbs[activeIdx].querySelector('img').src;
    }

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }
}

/* ── Búsqueda predictiva ─────────────────────────────────────── */

function initSearch() {
  var input    = $('#search-input');
  var dropdown = $('#search-dropdown');
  if (!input || !dropdown) return;

  var doSearch = debounce(async function(q) {
    if (q.length < 2) { dropdown.style.display = 'none'; return; }

    try {
      var res  = await fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5');
      var data = await res.json();
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];

      if (products.length === 0) { dropdown.style.display = 'none'; return; }

      /* Escapa todos los campos provenientes de la API (defensa XSS) */
      dropdown.innerHTML = products.map(function(p) {
        var safeUrl   = escapeHtml(p.url || '');
        var safeImg   = escapeHtml((p.featured_image && p.featured_image.url) || '');
        var safeTitle = escapeHtml(p.title || '');
        return '<a class="search-suggestion" href="' + safeUrl + '">' +
          '<img src="' + safeImg + '" alt="' + safeTitle + '" width="40" height="40" loading="lazy">' +
          '<span>' + safeTitle + '</span>' +
          '</a>';
      }).join('');
      dropdown.style.display = 'block';
    } catch (e) {
      dropdown.style.display = 'none';
    }
  }, 300);

  input.addEventListener('input', function() { doSearch(this.value.trim()); });

  document.addEventListener('click', function(e) {
    if (!input.contains(e.target) && !dropdown.contains(e.target)) {
      dropdown.style.display = 'none';
    }
  });
}

/* ── Barra de anuncio: cerrar ────────────────────────────────── */

function initAnnouncementBar() {
  var closeBtn = $('#announcement-close');
  var bar      = $('#announcement-bar');
  if (!closeBtn || !bar) return;

  closeBtn.addEventListener('click', function() {
    bar.style.display = 'none';
    try { sessionStorage.setItem('meuauau-announcement-closed', '1'); } catch(e) {}
  });

  try {
    if (sessionStorage.getItem('meuauau-announcement-closed') === '1') {
      bar.style.display = 'none';
    }
  } catch(e) {}
}

/* ── Inicializar contador del carrito ────────────────────────── */

async function initCartCount() {
  try {
    var count = await MeuAuAuCart.getCount();
    MeuAuAuCart.updateCountBadges(count);
  } catch(e) {}
}

/* ── Pausa animaciones fuera de pantalla (ahorro batería/CPU) ─ */
/*
   Aplica [data-anim-paused] a elementos animados cuando NO están
   en viewport, para que el navegador detenga las animaciones CSS.
   Si el usuario tiene prefers-reduced-motion, no hace nada (CSS ya
   forzó duración mínima en base.css).
*/
function initAnimationPauser() {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Selectores de elementos animados (marquee, carousel pets, banners shine) */
  var selectors = [
    '.kqr-marquee__track',
    '.kqr-carousel__track',
    '.shine-sweep',
    '[data-animated]'
  ];

  var nodes = $$(selectors.join(','));
  if (nodes.length === 0) return;

  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.removeAttribute('data-anim-paused');
      } else {
        entry.target.setAttribute('data-anim-paused', '');
      }
    });
  }, { rootMargin: '50px' });

  nodes.forEach(function(node) { io.observe(node); });
}

/* ── Inicialización global ───────────────────────────────────── */

document.addEventListener('DOMContentLoaded', function() {
  initAnnouncementBar();
  initMobileMenu();
  initHeroCarousel();
  initScrollCarousels();
  initProductPage();
  initCartPage();
  initCollectionFilters();
  initProductGallery();
  initSearch();
  initCartCount();
  initAnimationPauser();
});
